import {useMemo} from 'react';
import {useUrl} from '@shopify/hydrogen';

export function useNextParam(defaultPath: string) {
  const {searchParams} = useUrl();
  const next = useMemo(() => {
    const nextParam = searchParams.get('next') ?? '';
    return nextParam.startsWith('/') ? nextParam : defaultPath;
  }, [defaultPath, searchParams]);
  return next;
}
